function enhanceReducer(reducer, deferEffects) {
  function getValues(reduction) {
    function recur(values) {
      const next = reduction.next();
      values.push(next.value);
      return next.done ? values : recur(values);
    }

    return recur([]);
  }

  return function enhance(state, action) {
    const reduction = reducer(state, action);
    const values = getValues(reduction);
    const newState = values.pop();

    deferEffects(values);

    if (newState === undefined) {
      throw new Error('Reducer return `undefined`. State object expected.');
    }

    return newState;
  };
}

export function enhancer(createStore) {
  return function configureStore(rootReducer, initialState) {
    let store = null;
    let executeEffects = false;
    let wrappedDispatch = null;

    function callWithEffects(callback) {
      executeEffects = true;
      const result = callback();
      executeEffects = false;
      return result;
    }

    function deferEffects(effects) {
      if (executeEffects) {
        setTimeout(
          function callback() {
            effects.forEach(function fire(effect) {
              if (wrappedDispatch) {
                effect(wrappedDispatch);
              }
            });
          },
          0
        );
      }
    }

    callWithEffects(function callback() {
      store = createStore(enhanceReducer(rootReducer, deferEffects), initialState);
    });

    wrappedDispatch = function dispatch(...args) {
      return callWithEffects(function callback() {
        return store.dispatch(...args);
      });
    };

    return {
      ...store,
      dispatch: wrappedDispatch,
      replaceReducer(nextReducer) {
        store.replaceReducer(enhanceReducer(nextReducer, deferEffects), initialState);
      },
    };
  };
}
